/**
 * Current date as an ISO ``YYYY-MM-DD`` string (UTC, matching the app's
 * UTC date math). Centralised + injectable so date-dependent logic stays
 * testable — tests use ``vi.setSystemTime``.
 */
export const todayIso = (): string => new Date().toISOString().slice(0, 10);
